import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PubSub from "services/pubsub-service";
import * as PubSubActionType from "services/constants";
import { AppSettings } from "../../constants";
import * as UserActionType from "../constants";
import imageUpload from "assets/img/imageUpload.webp";
import Dropzone from "react-dropzone";
import { ChangePasswordModalHO } from "../Components/change-password-modal-Ho";
import FAQModalHO from "../Components/FAQ-myaccount";
import Input from "../../components/react-validation/components/input";
import * as Vali from "../../helper/validator-helper";
import Form from "../../components/react-validation/components/form";
import * as AuthActionType from "../../Auth/constants";
import "../my-account.scss";

class HomeOwnerMyAccount extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    UserProfile: PropTypes.object,
    IsOpenFormChangePassword: PropTypes.bool,
    ErrorMsg: PropTypes.array,
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
      isOpenFAQModal: false,
      firstName: this.props.UserProfile.firstName,
      lastName: this.props.UserProfile.lastName,
      phoneNumber: this.props.UserProfile.phoneNumber,
      daytimePhoneNumber: this.props.UserProfile.daytimePhoneNumber,
      email: this.props.UserProfile.email,
      cancelUploadList: {},
      deleteUploadList: {},
      listImages: [],

      isEdit: {},
      errorEmail: null,
      imageFile: null,
      imagePreview: this.props.UserProfile.profilePictureUrl || null,
      error: null,
      originalProfile: {
        firstName: this.props.UserProfile.firstName,
        lastName: this.props.UserProfile.lastName,
        phoneNumber: this.props.UserProfile.phoneNumber,
        daytimePhoneNumber: this.props.UserProfile.daytimePhoneNumber,
        email: this.props.UserProfile.email,
        imagePreview: this.props.UserProfile.profilePictureUrl || null,
      },
      imageFile: null,
      isFormChanged: false, // 🆕 added
      // ...
    };
  }

  componentDidMount() {
    // this.props.dispatch({
    //   type: UserActionType.GET_USER_BY_USERID_ASYNC,
    //   params: localStorage[AppSettings.S1_UID]
    // });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.UserProfile &&
      nextProps.UserProfile !== this.props.UserProfile
    ) {
      this.setState({
        firstName: nextProps.UserProfile.firstName,
        lastName: nextProps.UserProfile.lastName,
        phoneNumber: nextProps.UserProfile.phoneNumber,
        daytimePhoneNumber: nextProps.UserProfile.daytimePhoneNumber,
        email: nextProps.UserProfile.email,
        imagePreview: nextProps.UserProfile.profilePictureUrl,
        originalProfile: {
          firstName: nextProps.UserProfile.firstName,
          lastName: nextProps.UserProfile.lastName,
          phoneNumber: nextProps.UserProfile.phoneNumber,
          daytimePhoneNumber: nextProps.UserProfile.daytimePhoneNumber,
          email: nextProps.UserProfile.email,
          imagePreview: nextProps.UserProfile.profilePictureUrl,
        },
        isFormChanged: false,
        imageFile: null,
      });
    }
  }

  checkIfFormChanged = () => {
    const {
      originalProfile,
      firstName,
      lastName,
      phoneNumber,
      daytimePhoneNumber,
      email,
      imageFile,
      imagePreview,
    } = this.state;

    const changed =
      originalProfile.firstName !== firstName ||
      originalProfile.lastName !== lastName ||
      originalProfile.phoneNumber !== phoneNumber ||
      originalProfile.daytimePhoneNumber !== daytimePhoneNumber ||
      originalProfile.email !== email ||
      (imageFile && imagePreview !== originalProfile.imagePreview);

    this.setState({ isFormChanged: changed });
  };

  onDrop = (accepted, rejected) => {
    if (rejected.length || accepted.length !== 1) {
      this.setState({ error: "Only one image is allowed." });
      return;
    }

    const file = accepted[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      this.setState(
        {
          imageFile: file,
          imagePreview: reader.result,
          error: null,
        },
        this.checkIfFormChanged
      );
    };

    reader.readAsDataURL(file);
  };

  uploadImage = async () => {
    const { imageFile } = this.state;

    if (!imageFile) return;

    const formData = new FormData();
    formData.append("profilePicture", imageFile);

    this.props.dispatch({
      type: UserActionType.UPDATE_PROFILE_PHOTO_ASYNC,
      params: formData,
      callback: (data) => {
        if (data.error) {
          this.setState({
            errorEmail: data.error,
          });
        } else {
          this.setState({
            errorEmail: null,
          });
        }
      },
    });
  };

  onRemoveImage = (e) => {
    e.preventDefault();

    const { imageFile, imagePreview } = this.state;
    const { user } = this.props;

    if (!imagePreview) return; // No image to remove

    // If image is uploaded locally but not submitted
    if (imageFile && (!user || !user.imageUrl)) {
      this.setState({
        imageFile: null,
        imagePreview: null,
        isFormChanged: true,
      });
      return;
    }

    // Otherwise, remove from backend
    this.props.dispatch({
      type: UserActionType.REMOVE_PROFILE_PHOTO_ASYNC,
      callback: (data) => {
        if (data == "Profile Picture removed") {
          this.setState({
            imageFile: null,
            imagePreview: null,
            isFormChanged: true,
          });
        }
      },
    });
  };

  onChangeInput = (type, e) => {
    this.setState({ [type]: e.target.value }, this.checkIfFormChanged);
  };

  onEdit = (field) => () => {
    this.setState({
      isEdit: {
        [field]: true,
      },
    });
  };

  onSubmit = async (e) => {
    e.preventDefault();

    const {
      email,
      firstName,
      lastName,
      isFormChanged,
      imageFile,
      originalProfile,
      phoneNumber,
    } = this.state;

    if (!isFormChanged) return;

    if (
      !email ||
      !email.trim() ||
      !firstName ||
      !firstName.trim() ||
      !lastName ||
      !lastName.trim() ||
      !phoneNumber ||
      !phoneNumber.trim()
    ) {
      this.setState({
        error: "Please fill in required fields.",
      });
      return;
    }

    const isValidEmail = (email) =>
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
    if (!isValidEmail(email)) {
      return;
    }
  
    if (imageFile) {
      await this.uploadImage();
    }

    const values = {
      userId: this.props.UserProfile.userId,
      email: email,
      firstName: firstName,
      lastName: lastName,
      phoneNumber: this.state.phoneNumber,
      daytimePhoneNumber: this.state.daytimePhoneNumber,
    };

    const emailChanged = originalProfile.email !== email;

    this.props.dispatch({
      type: UserActionType.UPDATE_MY_PROFILE_ASYNC,
      params: values,
      callback: (data) => {
        if (data.error) {
          this.setState({ errorEmail: data.error });
        } else {
          if (emailChanged) {
            PubSub.publish(PubSubActionType.HOMEOWNER_CHANGE_EMAIL, {});
          } else {
            if (localStorage[AppSettings.S1_TOKEN]) {
              this.props.dispatch({
                type: AuthActionType.GET_CURRENT_USER_ASYNC,
                params: null,
                callback: (status, userData) => {
                  if (status && userData) {
                    this.setState({
                      firstName: userData.firstName,
                      lastName: userData.lastName,
                      email: userData.email,
                      phoneNumber: userData.phoneNumber,
                      daytimePhoneNumber: userData.daytimePhoneNumber,
                      imagePreview: userData.profilePictureUrl || null,
                    });
                  }
                },
              });
              setTimeout(() => {
                this.props.dispatch({
                  type: AuthActionType.GET_CURRENT_USER_ASYNC,
                  params: null,
                  callback: (status2, updatedUserData) => {
                    if (status2 && updatedUserData) {
                      this.setState({
                        imagePreview: updatedUserData.profilePictureUrl || null,
                      });
                    }
                  },
                });
              }, 1500); 
            }
          }

          this.setState({
            errorEmail: null,
            isFormChanged: false,
            originalProfile: {
              ...values,
              imagePreview: this.state.imagePreview,
            },
          });
        }
      },
    });
  };
  
  // onSubmit = async (e) => {
  //   e.preventDefault();

  //   const {
  //     email,
  //     firstName,
  //     lastName,
  //     isFormChanged,
  //     imageFile,
  //     originalProfile,
  //   } = this.state;

  //   if (!isFormChanged) return;

  //   if (
  //     !email ||
  //     !email.trim() ||
  //     !firstName ||
  //     !firstName.trim() ||
  //     !lastName ||
  //     !lastName.trim()
  //   ) {
  //     this.setState({
  //       error: "Please fill in required fields.",
  //     });
  //     return;
  //   }

  //   if (imageFile) {
  //     await this.uploadImage();
  //   }

  //   const values = {
  //     userId: this.props.UserProfile.userId,
  //     email: email,
  //     firstName: firstName,
  //     lastName: lastName,
  //     phoneNumber: this.state.phoneNumber,
  //     daytimePhoneNumber: this.state.daytimePhoneNumber,
  //   };

  //   const emailChanged = originalProfile.email !== email;

  //   this.props.dispatch({
  //     type: UserActionType.UPDATE_MY_PROFILE_ASYNC,
  //     params: values,
  //     callback: (data) => {
  //       console.log('data')
  //       if (data.error) {
  //         this.setState({ errorEmail: data.error });
  //       } else {
  //         if (emailChanged) {
  //           PubSub.publish(PubSubActionType.HOMEOWNER_CHANGE_EMAIL, {});
  //         } else {
  //           if (localStorage[AppSettings.S1_TOKEN]) {
  //             this.props.dispatch({
  //               type: AuthActionType.GET_CURRENT_USER_ASYNC,
  //               params: null,
  //               callback: (status, userData) => {
  //                 if (status && userData) {
  //                   this.setState({
  //                     firstName: userData.firstName,
  //                     lastName: userData.lastName,
  //                     email: userData.email,
  //                     phoneNumber: userData.phoneNumber,
  //                     daytimePhoneNumber: userData.daytimePhoneNumber,
  //                     imagePreview: userData.profilePictureUrl || null,
  //                   });
  //                 }
  //               },
  //             });

  //             // Call it again after short delay to ensure image is updated
  //             setTimeout(() => {
  //               this.props.dispatch({
  //                 type: AuthActionType.GET_CURRENT_USER_ASYNC,
  //                 params: null,
  //                 callback: (status2, updatedUserData) => {
  //                   if (status2 && updatedUserData) {
  //                     this.setState({
  //                       imagePreview: updatedUserData.profilePictureUrl || null,
  //                     });
  //                   }
  //                 },
  //               });
  //             }, 1500); // 1.5s delay
  //           }
  //         }

  //         this.setState({
  //           errorEmail: null,
  //           isFormChanged: false,
  //           originalProfile: {
  //             ...values,
  //             imagePreview: this.state.imagePreview,
  //           },
  //         });
  //       }
  //     },
  //   });
  // };

  handleUseInitial = () => {
    const { firstName, lastName } = this.state;
    const fullName = `${firstName} ${lastName}`.trim();
    const avatarDataUrl = this.createInitialAvatar(fullName);

    fetch(avatarDataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "avatar.png", { type: "image/png" });

        this.setState(
          {
            imageFile: file,
            imagePreview: avatarDataUrl,
            error: null,
          },
          this.checkIfFormChanged
        );
      });
  };

  createInitialAvatar(
    name,
    size = 120,
    bgColor = "#4267b2",
    textColor = "#fff"
  ) {
    const initials = name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext("2d");
    ctx.fillStyle = bgColor;
    ctx.fillRect(0, 0, size, size);

    ctx.fillStyle = textColor;
    ctx.font = `${size * 0.5}px Arial`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(initials, size / 2, size / 2);

    return canvas.toDataURL("image/png");
  }

  renderError = () => {
    const { error } = this.state;

    if (error) {
      setTimeout(this.onClearError, 5000);
      return (
        <div
          className="alert alert-danger"
          style={{ width: "100%", margin: "0 15px 15px" }}
        >
          <p style={{ fontSize: 14 }}>{error}</p>
          <i
            className="fa fa-close"
            style={{
              position: "absolute",
              top: 14,
              right: 14,
              cursor: "pointer",
            }}
            onClick={this.onClearError}
          />
        </div>
      );
    }

    return null;
  };

  onChangePasword = (e, data, callback) => {
    this.props.dispatch({
      type: UserActionType.CHANGE_PASSWORD_ASYNC,
      params: data,
      callback: (status, res) => {
        if (status === false) {
          callback(false, res);
        } else {
          this.toggleModal();
        }
      },
    });
  };

  toggleModal = () => {
    this.setState({ isOpenModal: !this.state.isOpenModal });
  };

  toggleFAQModal = () => {
    this.setState({ isOpenFAQModal: !this.state.isOpenFAQModal });
  };

  render() {
    const { firstName, lastName, email, daytimePhoneNumber, phoneNumber } =
      this.state;
    const acceptFileType =
      "image/jpeg, image/png , image/bmp, image/jpg, image/tiff";

    return (
      <div className="container-fluid my-account">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-7 col-lg-7">
            <div className="update-section">
              <div className="row image-upload-profile">
                <div className="image-category col-md-5 col-lg-5 col-xs-6">
                  <button
                    className="remove-pic"
                    onClick={this.onRemoveImage}
                    disabled={!this.state.imagePreview}
                  >
                    <i class="fa fa-trash text-danger " fontSize={20} aria-hidden="true"></i>
                  </button>
                  <div className="profile-image-box ">
                    <img
                      className="profile-image"
                      src={this.state.imagePreview || imageUpload}
                      alt="profile"
                    />
                  </div>
                </div>

                <div className="upload-buttons col-xs-6 col-md-5 col-lg-5">
                  <Dropzone
                    multiple={false}
                    accept={acceptFileType}
                    onDrop={this.onDrop}
                    noClick={true}
                    noKeyboard={true}
                    ref={(node) => {
                      if (node) this.dropzoneRef = node;
                    }}
                    className="category-images-dropzone"
                  >
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary btn-siteone"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.dropzoneRef.open();
                        }}
                      >
                        <i class="fa fa-picture-o" aria-hidden="true"></i>{" "}
                        Upload
                      </button>
                    </div>
                  </Dropzone>

                  <button
                    className="use-initial"
                    onClick={this.handleUseInitial}
                  >
                    <i class="fa fa-user-o" aria-hidden="true"></i> Use Initial
                  </button>
                </div>
              </div>
              <div className="row form-div">
                <Form
                  ref={(c) => {
                    this.form = c;
                  }}
                  className="profile-form"
                  onSubmit={this.onSubmit.bind(this)}
                >
                  <div className="form-group row">
                    <div className="col-xs-12 col-sm-6">
                      <label>
                        First name <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="text"
                        name="firstName"
                        value={firstName}
                        placeholder="First name"
                        className="form-control"
                        max="40"
                        maxLength="40"
                        validations={[Vali.required, Vali.maxlength]}
                        onChange={(e) => this.onChangeInput("firstName", e)}
                      />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <label>
                        Last name <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="text"
                        name="lastName"
                        value={lastName}
                        placeholder="Last name"
                        className="form-control"
                        max="40"
                        maxLength="40"
                        validations={[Vali.required, Vali.maxlength]}
                        onChange={(e) => this.onChangeInput("lastName", e)}
                      />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>
                      Phone Number <span className="text-danger">*</span>
                    </label>
                    <Input
                      type="text"
                      name="phoneNumber"
                      value={phoneNumber}
                      placeholder="xxx-xxx-xxxx"
                      className="form-control"
                      max="10"
                      maxLength="10"
                      validations={[Vali.phoneOptional, Vali.required]}
                      onChange={(e) => this.onChangeInput("phoneNumber", e)}
                    />
                  </div>

                  <div className="form-group">
                    <label>Daytime Phone Number</label>
                    <Input
                      type="text"
                      name="daytimePhoneNumber"
                      value={daytimePhoneNumber}
                      placeholder="xxx-xxx-xxxx"
                      className="form-control"
                      max="10"
                      maxLength="10"
                      validations={[Vali.phoneOptional]}
                      onChange={(e) =>
                        this.onChangeInput("daytimePhoneNumber", e)
                      }
                    />
                  </div>

                  {AppSettings.clientTypeValue === "Homeowner" ? (
                    <div className="form-group">
                      <label>
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <Input
                        type="text"
                        name="email"
                        value={email}
                        placeholder="Email address"
                        className="form-control"
                        max="256"
                        maxLength="256"
                        validations={[
                          Vali.required,
                          Vali.emailvali,
                          Vali.maxlength,
                        ]}
                        onChange={(e) => this.onChangeInput("email", e)}
                      />
                      {this.state.errorEmail && (
                        <div className="text-danger">
                          {this.state.errorEmail}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="form-group">
                      <label>Email Address</label>
                      <div style={{ fontWeight: 600 }}>
                        {this.props.UserProfile.email}
                      </div>
                    </div>
                  )}

                  <div>
                    <button
                      type="submit"
                      className="btn btn-primary btn-siteone submit-button"
                      disabled={!this.state.isFormChanged}
                    >
                      Update Profile
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-12 col-md-5 col-lg-5 ">
            <div className="other-action">
              <p className="other-actions-title">Other Actions</p>
              <div className="action-links">
                <a
                  className="action-link s1-change-password"
                  onClick={this.toggleModal}
                >
                  Change Password
                  <span className="arrow">›</span>
                </a>
                <a className="action-link" onClick={this.toggleFAQModal}>
                  FAQ / Help
                  <span className="arrow">›</span>
                </a>
                <a
                  href="/logout?action=true"
                  className="action-link logout-link"
                >
                  Log out
                </a>
              </div>
            </div>
          </div>
        </div>
        {this.state.isOpenModal && (
          <ChangePasswordModalHO
            isOpen={this.state.isOpenModal}
            errorMsg={this.props.ErrorMsg}
            onChangePassword={this.onChangePasword}
            closeModal={this.toggleModal}
          />
        )}
        {this.state.isOpenFAQModal && (
          <FAQModalHO
            isOpen={this.state.isOpenFAQModal}
            onChangePassword={this.onChangePasword}
            closeModal={this.toggleFAQModal}
            dispatch={this.props.dispatch}
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return state.UserStore;
};

export default connect(mapStateToProps)(HomeOwnerMyAccount);



// WEBPACK FOOTER //
// ./src/User/Containers/homeowner-my-account.js